import { icons } from './constant';

// ==============================|| PARTNER MENU ITEMS ||============================== //

const partner = {
	id: 'partner_masters',
	title: 'Partner',
	type: 'collapse',
	icon: icons.CorporateFareIcon,
	children: [
		{
			id: 'insurance-partner-type',
			title: 'Insurance Partner Type',
			type: 'item',
			url: '/insurance-partner-types',
			icon: icons.IconEmployees,
			breadcrumbs: true,
		},
		{
			id: 'insurance-partner',
			title: 'Insurance Partner',
			type: 'item',
			url: '/insurance-partners',
			icon: icons.GroupIcon,
			breadcrumbs: true,
		},
		{
			id: 'college-institutes',
			title: 'Institute Types',
			type: 'item',
			url: '/institutionTypes',
			icon: icons.GroupIcon,
			breadcrumbs: true,
		},
		{
			id: 'partner-categorisation',
			title: 'Partner Categorisation',
			type: 'item',
			url: '/partnerCategorisations',
			icon: icons.GroupIcon,
			breadcrumbs: true,
		},
		{
			id: 'course-types',
			title: 'Course Types',
			type: 'item',
			url: '/courseTypes',
			icon: icons.GroupIcon,
			breadcrumbs: true,
		},
		{
			id: 'loanTypes',
			title: 'Loan Types',
			type: 'item',
			url: '/loanTypes',
			icon: icons.GroupIcon,
			breadcrumbs: true,
		},
		{
			id: 'groups',
			title: 'Groups',
			type: 'item',
			url: '/groups',
			icon: icons.CorporateFareIcon,
			breadcrumbs: true,
		},
		{
			id: 'partners',
			title: 'Partners',
			type: 'item',
			url: '/partners',
			icon: icons.CorporateFareIcon,
			breadcrumbs: true,
		},
	],
};

export default partner;
